import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { PriceRuleForm } from "../components";

export const CreatePriceRule: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("productId");
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Règle de prix"
        subtitle="Créer une nouvelle règle de prix"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/price-rules`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle règle de prix" />
          <PriceRuleForm
            productId={productId ? +productId : undefined}
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/price-rules")}
          />
        </div>
      </div>
    </>
  );
};
